module.exports = __webpack_public_path__ + "img/6721061369a793be93376ece7b159e95.png";